import { useCallback } from 'react';

import { type ShortUrlResponse } from '@air/api/types';

import { mergeFormShareLinkApiUpdatePatch } from '~/components/Modals/ContentCollectionModal/mergeFormShareLinkApiUpdatePatch';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type ShareUrlUpdateHandlerProps, useUpdateShortId } from '~/swr-hooks/shortUrl/useUpdateShortId';

type UseUpdateContentCollectionLinkParams = {
  formId: string;
  shortIdInfo: ShortUrlResponse;
};

export const useUpdateContentCollectionLink = ({ formId, shortIdInfo }: UseUpdateContentCollectionLinkParams) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { updateShortId } = useUpdateShortId();

  const onShortUrlUpdate = useCallback(
    async ({ props }: { props: ShareUrlUpdateHandlerProps }) => {
      const workspaceId = currentWorkspace?.id;

      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      await updateShortId.mutateAsync({
        objectId: formId,
        boardContext: shortIdInfo.boardContext,
        updatePayload: {
          workspaceId,
          ...mergeFormShareLinkApiUpdatePatch(shortIdInfo, props),
          shortId: shortIdInfo.id,
        },
      });
    },
    [formId, shortIdInfo, updateShortId, currentWorkspace?.id],
  );

  return {
    onShortUrlUpdate,
    isLoading: updateShortId.isPending,
  };
};
